import React from 'react'
import { withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, Empty, Text, ExternalLink } from 'components';
import { Container, Button, Icon } from 'semantic-ui-react'

import { ModalInviteUser, ModalOptions } from 'modals';

import { Auth, API } from 'services';
import { BreadcrumbHelper, Typeof, Functions } from 'utils';

const USERS_PER_PAGE = 10;

class ClinicUserListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      users: props.users,
      userCriteria: '',
      showUserInvitationModal: false,
      showUserRevokeModal: false
    };

    this.handleUserSearch = this.handleUserSearch.bind(this);

    this.toggleUserInvitationModal = this.toggleUserInvitationModal.bind(this);
    this.handleUserInvitationModal = this.handleUserInvitationModal.bind(this);

    this.toggleUserRevokeModal = this.toggleUserRevokeModal.bind(this);
    this.handleUserRevokeModal = this.handleUserRevokeModal.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');

    BreadcrumbHelper.push('Utilisateurs');
    BreadcrumbHelper.flush();
  }

  handleUserSearch(criteria) {

    this.setState({
      userCriteria: criteria
    });
  }

  toggleUserInvitationModal() {

    this.setState({
      showUserInvitationModal: !this.state.showUserInvitationModal
    });

  }

  handleUserInvitationModal(user) {

    if (Typeof.object(user)) {

      let users = [...this.state.users];
      users.push(user);

      this.setState({
        users: users
      });
    }

    this.toggleUserInvitationModal();
  }

  toggleUserRevokeModal(user) {

    this.setState({
      showUserRevokeModal: !this.state.showUserRevokeModal,
      targetUser: user
    });
  }

  handleUserRevokeModal(result, setProcessing) {

    if(result !== ModalOptions.OPTION_YES) {
      this.toggleUserRevokeModal();
    } else {

      setProcessing(true);

      let clinic = Auth.getManagedClinic();
      let toRevoke = this.state.targetUser;

      API.delete(`/clinics/${clinic.id}/veterinarians/${toRevoke.id}`)
        .then(() => {

          //Remove locally
          let users = this.state.users.filter((user) => {

            return user.id !== toRevoke.id;
          });

          this.setState({
            users: users,
            targetUser: null,
            showUserRevokeModal: false
          });

        });
    }
  }

  render() {

    const { users } = this.state;

    let columns = [
      {
        id: 'email',
        header: 'Adresse e-mail',
        value: (user) => user.email,
        render: (user, email) => {
          return (
            <ExternalLink target={`mailto:${email}`}>
              <Icon name="mail" />
              <Text>{email}</Text>
            </ExternalLink>
          )
        },
        fit: true
      },
      {
        id: 'lastname',
        header: 'Nom',
        value: (user) => user.lastname,
        render: (user, lastname) => {
          if (!Typeof.string(lastname)) {
            return <Empty />;
          }

          return (
            <Text style={{"uppercase" : true}}>{lastname}</Text>
          )
        },
        fit: true
      },
      {
        id: 'firstname',
        header: 'Prénom',
        value: (user) => user.firstname,
        render: (user, firstname) => {
          if(!Typeof.string(firstname)) {
            return <Empty />;
          }

          return (
            <Text style={{"capitalize" : true}}>{firstname}</Text>
          )
        }
      },
      {
        id: 'phone',
        header: 'Numéro de téléphone',
        value: (user) => user.phone?.trim(),
        render: (user, phone) => {

          if (!phone) {
            return <Empty />;
          }

          return (
            <ExternalLink target={`tel:${phone}`}>
              <Icon name="phone" />
              <Text>{Functions.formatPhone(phone)}</Text>
            </ExternalLink>
          )
        },
        fit: true
      },
      {
        id: 'activated',
        header: 'Actif',
        value: (user) => user.activated,
        render: (user, activated) => {

          return (
            <Icon name={activated ? 'checkmark' : 'times'} color={activated ? 'green' : 'red'} />
          )
        },
        fit: true
      },
      {
        id: 'dissociate',
        header: 'Actions',
        render: (user) => {

          return (
            <Button size="mini" color="red" onClick={() => this.toggleUserRevokeModal(user)}>
              <Icon name="unlink" />
              Révoquer
            </Button>
          )
        },
        fit: true
      }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Users */}
          <Section title="Utilisateurs" onSearch={this.handleUserSearch} actions={[

            // Add user
            <Button icon="add" content="Inviter un utilisateur" onClick={this.toggleUserInvitationModal} key={0} />
          ]}>

            {users.length > 0 ? (

              <React.Fragment>

                {/* Number of available users */}
                <InfosBar mode="column">
                  <span>{users.length > 1 ? `${users.length} utilisateurs disponibles` : '1 utilisateur disponible'}</span>
                </InfosBar>

                {/* users list */}
                <Table columns={columns}
                  criteria={this.state.userCriteria}
                  items={users}
                  itemsPerPage={USERS_PER_PAGE}
                  // onSelect={this.handleSensorSelect}
                  messageEmpty="Aucun utilisateur ne correspond à votre recherche"
                  getRowClass={(user) => !user.activated ? 'warning' : undefined}
                />

              </React.Fragment>

            ) : (

              // No user available
              <InfosBar mode="row">
                <span>Aucun utilisateur disponible</span>
              </InfosBar>

            )}

          </Section>

        </Container>

        {/* Modal invite user */}
        {this.state.showUserInvitationModal &&
          <ModalInviteUser onClose={this.handleUserInvitationModal} />
        }

        {/* Modal revoke user */}
        {this.state.showUserRevokeModal &&
          <ModalOptions onClose={this.handleUserRevokeModal} icon="unlink" title="Révoquer l'accès" message={<span>Vous êtes sur le point de révoquer l'accès de cet utilisateur.<br /><br />Voulez vous continuer ?</span>} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

      </React.Fragment>
    );
  }
}


export default withRouter(ClinicUserListScene);
